import { useState, type PropsWithChildren } from "react";
import { Calendar } from "@/ds/shadcn/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/ds/shadcn/components/ui/popover";

export interface DatePickerProps extends PropsWithChildren {
	value: Date;
	onDateSelected: (date: Date) => void;
}

export const DatePicker = (props: DatePickerProps): React.JSX.Element => {
	const {
		value,
		onDateSelected,
		children
	} = props;

	const [open, setOpen] = useState(false);

	const handleSelect = (date: Date | undefined) => {
		if (!date) return;

		setOpen(false);
		onDateSelected(date);
	};

	return (
		<Popover open={open} onOpenChange={setOpen}>
			<PopoverTrigger asChild>
				{children}
			</PopoverTrigger>

			<PopoverContent className="w-auto p-0" align="start">
				<Calendar
					mode="single"
					selected={value}
					onSelect={handleSelect} />
			</PopoverContent>
		</Popover>
	);
};
